import { FILTERS_LIST } from '../constants';

export const excludeFilterByName = (excludeName: string) =>
  FILTERS_LIST.filter(({ filterName }) => filterName !== excludeName);
